export const TEMPLATE_ACCOMODATION_STATE_KEY = 'TEMPLATE_ACCOMODATION_REDUCER';
// export const getTemplateById = (state: any, RequestId: string) =>
export const getOffices = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].offices;
export const getEmployees = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].employees;
export const getTemplatePatterns = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].templatePatterns;
export const getRCDByLocationNumber = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].rcd;
export const getCurrentTemplatePattern = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].currentTemplatePattern;
export const getChangeResults = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].changeResults;
export const getSuccessErrorReport = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].successErrorReport;
export const getTemplateById = (state: any, exceptionId: string) =>
  state[TEMPLATE_ACCOMODATION_STATE_KEY].exception.contents.find((exception) => exception.exceptionId === exceptionId);

export const getTemplateAccomodations = (state) =>
  state[TEMPLATE_ACCOMODATION_STATE_KEY].requests.map(({ RequestId, ...rest }, idx) => ({
    key: `${RequestId}-${idx}`,
    RequestId,
    ...rest,
  }));

export const getLoading = (state) => state[TEMPLATE_ACCOMODATION_STATE_KEY].loading;
export const getCurrentPattern = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].currentPattern;
export const getSaveLoading = (state: any) => state[TEMPLATE_ACCOMODATION_STATE_KEY].saveLoading;
export const getSaveAccommodationSuccess = (state: any) =>
  state[TEMPLATE_ACCOMODATION_STATE_KEY].saveAccommodationSuccess;

export const getSaveAccommodationFailureMssg = (state: any) =>
  state[TEMPLATE_ACCOMODATION_STATE_KEY].saveAccommodationFailureMssg;
